import { render, staticRenderFns } from "./RefundLink.vue?vue&type=template&id=d24bf398"
import script from "./RefundLink.vue?vue&type=script&lang=js"
export * from "./RefundLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports